const state = () => ({
  shareLink: '',
  invitationLoading: true,
  codeCopied: false
});

const getters = {
  shareLink(state) {
    return state.shareLink;
  },
  invitationLoading(state) {
    return state.invitationLoading;
  },
  codeCopied(state) {
    return state.codeCopied;
  }
};

const mutations = {
  setShareLink(state, payload) {
    state.shareLink = payload;
  },
  setInvitationLoading(state, payload) {
    state.invitationLoading = payload;
  },
  setCodeCopied(state, payload) {
    state.codeCopied = payload;
  },
  resetStore(s) {
    Object.assign(s, state());
  }
};

const actions = {
  setShareLink({ commit }, payload) {
    commit('setShareLink', payload);
  },
  setInvitationLoading({ commit }, payload) {
    commit('setInvitationLoading', payload);
  }
};

export const invitation = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
